<div class="page-container">
  <div class="page-header">
    <h1>My Events</h1>
    <p>Events you hold tickets for. Open one to see its tickets and wallet.</p>
  </div>

  <nz-spin [nzSpinning]="loading">
    <div *ngIf="events.length > 0; else noEvents" class="events-grid">
      <a
        *ngFor="let event of events"
        class="event-card"
        [routerLink]="['/my-events', event.eventUid]"
      >
        <div class="event-card-head">
          <h3 class="event-card-name">{{ event.name }}</h3>
          <span *ngIf="event.walletsEnabled" class="event-wallet-tag">Wallet</span>
        </div>

        <div class="event-card-meta">
          <span class="event-meta-item">
            <i nz-icon nzType="calendar" aria-hidden="true"></i>
            {{ (event.date | date: 'mediumDate') || 'Date to be announced' }}
          </span>
          <span class="event-meta-item">
            <i nz-icon nzType="environment" aria-hidden="true"></i>
            {{ event.location }}
          </span>
        </div>

        <div class="event-card-foot">
          <span class="event-ticket-count">
            {{ event.ticketCount }} {{ event.ticketCount === 1 ? 'ticket' : 'tickets' }}
          </span>

          <!--
            Only ever this event's balance. Funds on a ticket are spendable at that event and
            nowhere else, so a figure combined across events would be a number the customer
            cannot act on.
          -->
          <span *ngIf="event.walletsEnabled && event.walletTotals.length" class="event-wallet-total">
            <i nz-icon nzType="wallet" aria-hidden="true"></i>
            <span *ngFor="let total of event.walletTotals" class="event-wallet-leg">
              {{ total.balance }} {{ total.currencyCode }}
            </span>
          </span>
        </div>
      </a>
    </div>

    <ng-template #noEvents>
      <div class="empty-state">
        <div class="empty-icon">
          <i nz-icon nzType="calendar" aria-hidden="true"></i>
        </div>
        <h3 class="empty-title">No Events Yet</h3>
        <p class="empty-desc">
          Once you buy tickets, the events they belong to will appear here.
        </p>
        <a nz-button nzType="primary" routerLink="/events">Browse Events</a>
      </div>
    </ng-template>
  </nz-spin>
</div>
